import React from "react";
import ReturnDetail from "../features/return/ReturnDetail";

const ReturnHistoryDetailPage = () => {
  return <ReturnDetail />;
};

export default ReturnHistoryDetailPage;
